import { render, staticRenderFns } from "./YuboyaProList.vue?vue&type=template&id=214e25e4&scoped=true&"
import script from "./YuboyaProList.vue?vue&type=script&lang=ts&"
export * from "./YuboyaProList.vue?vue&type=script&lang=ts&"
import style0 from "./YuboyaProList.vue?vue&type=style&index=0&id=214e25e4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214e25e4",
  null
  
)

export default component.exports